import authReducer from "./auth/reducer";
import commonReducer from "./common/reducer";
import examReducer from "./exam/reducer";
import feedbackReducer from "./feedback/reducer";
import sampleTestReducer from "./sampleTest/reducer";

const reducers = {
  commonReducer,
  authReducer,
  examReducer,
  feedbackReducer,
  sampleTestReducer
};

export default reducers;
